<app-breadcrumb [title]="'Vehiculos'" [items]="['PESV', 'Diagnostico']" [active_item]="'Vehiculos'"></app-breadcrumb>

<div class="container-fluid">
    <div class="card">
        <div class="card-header d-flex align-items-center bg-primary text-white">
            <i class="icofont icofont-car-alt-4 me-2"></i>
            <h5 class="mb-0"><strong>VEHICULOS PESV</strong></h5>
        </div>

        <div class="card-body">
            <div class="row mb-3">
                <div class="col-sm-12 col-md-4 ms-auto">
                    <div class="input-group">
                        <input type="text" class="form-control"
                            placeholder="Buscar por placa, interno, marca, modelo, propietario..." [(ngModel)]="filtro"
                            (input)="aplicarFiltro()" />
                        <span class="input-group-text">
                            <i class="fa fa-search"></i>
                        </span>
                    </div>
                </div>
            </div>

            <div *ngIf="cargando" class="text-center py-4">
                <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Cargando...</span>
                </div>
            </div>

            <div *ngIf="!cargando" class="table-responsive tabla-con-scroll">
                <table class="table table-hover table-bordered align-middle mb-0" id="tblVehiculosPesv">
                    <thead class="bg-primary">
                        <tr>
                            <th class="text-center"><strong>PLACA</strong></th>
                            <th class="text-center"><strong>FECHA DE VERIFICACION O INGRESO</strong></th>
                            <th class="text-center"><strong>NUMERO MOTOR</strong></th>
                            <th class="text-center"><strong>LICENCIA DE TRANSITO</strong></th>
                            <th class="text-center"><strong>KILOMETRAJE</strong></th>
                            <th class="text-center"><strong>ACCIONES</strong></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            *ngFor="let vehiculo of vehiculosFiltrados | paginate: { itemsPerPage: pageSize, currentPage: page }; let i = index">
                            <td class="text-center">{{ vehiculo.placa || '-' }}</td>
                            <td class="text-center">{{ formatearFecha(vehiculo.afiliacion) }}</td>
                            <td class="text-center">{{ vehiculo.motor || '-' }}</td>
                            <td class="text-center">{{ vehiculo.matricula || '-' }}</td>
                            <td class="text-center">{{ vehiculo.kilometraje || '-' }}</td>
                            <td class="text-center">
                                <button type="button" class="btn btn-outline-primary btn-sm"
                                    (click)="abrirModalDiagnosticoVehiculo(vehiculoDiagnosticoModal, vehiculo)">
                                    Diagnostico
                                </button>
                            </td>
                        </tr>
                        <tr *ngIf="!vehiculosFiltrados.length">
                            <td colspan="6" class="text-center py-3">No se encontraron vehiculos.</td>
                        </tr>
                    </tbody>
                </table>

                <div class="d-flex justify-content-between align-items-center mt-4">
                    <div class="d-flex align-items-center">
                        <label for="pageSizeVehiculosPesv" class="me-2">Mostrar:</label>
                        <select id="pageSizeVehiculosPesv" class="form-select w-auto" [(ngModel)]="pageSize"
                            (change)="page = 1">
                            <option *ngFor="let size of [5, 10, 20, 50, 100]" [value]="size">{{ size }}</option>
                        </select>
                        <span class="ms-2">registros por pagina</span>
                    </div>

                    <div class="text-center flex-grow-1">
                        Total Registros:
                        <a class="badge badge-primary"><b>{{ vehiculosFiltrados?.length || 0 }}</b></a>
                    </div>

                    <div class="text-end paginador-personalizado">
                        <pagination-controls (pageChange)="page = $event" [maxSize]="5" [directionLinks]="true"
                            [autoHide]="true" previousLabel="Anterior" nextLabel="Siguiente">
                        </pagination-controls>
                    </div>
                </div>

                <div class="mt-4">
                    <div class="btn-showcase text-center">
                        <button class="btn btn-outline-success-2x" type="button" placement="top" ngbTooltip="Exportar a Excel"
                            (click)="exportarExcel('tblVehiculosPesv','listado_vehiculos_pesv')">
                            <i class="icofont icofont-file-excel"></i> EXCEL
                        </button>

                        <button class="btn btn-outline-danger-2x" type="button" placement="top" ngbTooltip="Exportar a PDF"
                            (click)="exportToPDF('tblVehiculosPesv','listado_vehiculos_pesv','Listado Vehiculos PESV')">
                            <i class="icofont icofont-file-pdf"></i> PDF
                        </button>
                    </div>
                </div>
            </div>

            <div class="row mt-4">
                <div class="col-12 d-flex justify-content-center">
                    <button type="button" class="btn btn-primary" (click)="guardarTodoVehiculosPesv()"
                        [disabled]="guardandoTodo || !vehiculosFiltrados.length">
                        {{ guardandoTodo ? 'Guardando...' : 'Guardar todo' }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #vehiculoDiagnosticoModal let-modal>
    <div class="modal-header bg-primary text-white">
        <h5 class="modal-title ">DIAGNÓSTICO VEHÍCULO PESV</h5>
        <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>

    <div class="modal-body" *ngIf="vehiculoModalSeleccionado as vehiculo">
        <ngb-accordion #vehiculoAccordion="ngbAccordion" [closeOthers]="true" activeIds="panel-basicos">
            <ngb-panel id="panel-basicos">
                <ng-template ngbPanelTitle>
                    <strong>DATOS BÁSICOS</strong>
                </ng-template>
                <ng-template ngbPanelContent>
                    <div class="row g-3">
                        <div class="col-md-4">
                            <label class="form-label"><strong>PLACA</strong></label>
                            <input class="form-control" [value]="vehiculo.placa || '-'" disabled />
                        </div>
                        <div class="col-md-4">
                            <label class="form-label"><strong>FECHA DE VERIFICACION O INGRESO</strong></label>
                            <input class="form-control" [value]="formatearFecha(vehiculo.afiliacion)" disabled />
                        </div>
                        <div class="col-md-4">
                            <label class="form-label"><strong>NUMERO DE MOTOR</strong></label>
                            <input class="form-control" [value]="vehiculo.motor || '-'" disabled />
                        </div>
                        <div class="col-md-4">
                            <label class="form-label"><strong>LICENCIA DE TRANSITO</strong></label>
                            <input class="form-control" [value]="vehiculo.matricula || '-'" disabled />
                        </div>
                        <div class="col-md-4">
                            <label class="form-label"><strong>KILOMETRAJE</strong></label>
                            <input class="form-control" [value]="vehiculo.kilometraje || '-'" disabled />
                        </div>
                        <div class="col-md-4">
                            <label class="form-label"><strong>CIUDAD</strong></label>
                            <select class="form-select" [ngModel]="obtenerCiudadActual(vehiculo)"
                                (ngModelChange)="actualizarCiudadVehiculo(vehiculo, $event)">
                                <option [ngValue]="null" disabled>Seleccione ciudad</option>
                                <option *ngFor="let ciudad of ciudades" [ngValue]="ciudad">{{ ciudad }}</option>
                            </select>
                        </div>
                        <div class="col-md-8">
                            <label class="form-label"><strong>SEDE / OPERACIÓN A LA QUE ESTÁ ASIGNADO EL VEHÍCULO</strong></label>
                            <select class="form-select" [ngModel]="obtenerNombreSedeActual(vehiculo)"
                                (ngModelChange)="actualizarSedeVehiculo(vehiculo, $event)">
                                <option [ngValue]="null" disabled>Seleccione sede</option>
                                <option *ngFor="let sede of sedes" [ngValue]="sede.nombre_sede">{{ sede.nombre_sede }}</option>
                            </select>
                        </div>
                    </div>
                </ng-template>
            </ngb-panel>

            <ngb-panel id="panel-especificaciones">
                <ng-template ngbPanelTitle>
                    <strong>ESPECIFICACIONES DEL VEHÍCULO</strong>
                </ng-template>
                <ng-template ngbPanelContent>
                    <div class="row g-3">
                        <div class="col-md-4">
                            <label class="form-label"><strong>NÚMERO VIN</strong></label>
                            <input type="text" class="form-control" [(ngModel)]="vehiculo.vin" placeholder="Ingrese numero VIN" />
                        </div>
                        <div class="col-md-4">
                            <label class="form-label"><strong>FECHA FABRICACIÓN</strong></label>
                            <input type="date" class="form-control" [(ngModel)]="vehiculo.fecha_fabricacion" placeholder="Seleccione fecha de fabricación" />
                        </div>
                        <div class="col-md-4">
                            <label class="form-label"><strong>TARJETA DE OPERACIÓN</strong></label>
                            <input type="number" class="form-control" [(ngModel)]="vehiculo.tarjeta_operacion" placeholder="Ingrese tarjeta de operación" />
                        </div>
                        <div class="col-md-4">
                            <label class="form-label"><strong>PROMEDIO DE KILOMETRAJE AL MES</strong></label>
                            <input type="number" class="form-control" [(ngModel)]="vehiculo.promedio_kilometraje" placeholder="Ingrese promedio mensual" />
                        </div>
                        <div class="col-md-4">
                            <label class="form-label"><strong>CLASE DE VEHICULO</strong></label>
                            <input class="form-control" [value]="vehiculo.tipoVehiculo?.tipos || '-'" disabled />
                        </div>
                        <div class="col-md-4">
                            <label class="form-label"><strong>TIPO DE VEHICULO</strong></label>
                            <select class="form-select" [ngModel]="obtenerTipoVehiculoSeleccionado(vehiculo)"
                                (ngModelChange)="actualizarTipoVehiculo(vehiculo, $event)">
                                <option [ngValue]="null" disabled>Seleccione tipo de vehiculo</option>
                                <option *ngFor="let tipo of tiposVehiculo" [ngValue]="tipo.id">{{ tipo.descripcion }}</option>
                            </select>
                        </div>
                        <div class="col-md-4">
                            <label class="form-label"><strong>MARCA</strong></label>
                            <input class="form-control" [value]="vehiculo.marcas?.marca || '-'" disabled />
                        </div>
                        <div class="col-md-4">
                            <label class="form-label"><strong>MODELO</strong></label>
                            <input class="form-control" [value]="vehiculo.modelo || '-'" disabled />
                        </div>
                        <div class="col-md-4">
                            <label class="form-label"><strong>COLOR</strong></label>
                            <input class="form-control" [value]="vehiculo.color || '-'" disabled />
                        </div>
                        <div class="col-md-4">
                            <label class="form-label"><strong>LINEA</strong></label>
                            <input class="form-control" [value]="vehiculo.linea || '-'" disabled />
                        </div>
                        <div class="col-md-4">
                            <label class="form-label"><strong>MATRICULA</strong></label>
                            <input class="form-control" [value]="vehiculo.matricula || '-'" disabled />
                        </div>
                    </div>
                </ng-template>
            </ngb-panel>

            <ngb-panel id="panel-propietario">
                <ng-template ngbPanelTitle>
                    <strong>DATOS DEL PROPIETARIO</strong>
                </ng-template>
                <ng-template ngbPanelContent>
                    <div class="row g-3">
                        <div class="col-md-4">
                            <label class="form-label"><strong>NOMBRE</strong></label>
                            <input class="form-control" [value]="(nombrePropietario(vehiculo) || '-')" disabled />
                        </div>
                        <div class="col-md-4">
                            <label class="form-label"><strong>CEDULA O NIT</strong></label>
                            <input class="form-control" [value]="vehiculo.propietario?.cedula || '-'" disabled />
                        </div>
                        <div class="col-md-4">
                            <label class="form-label"><strong>NUMERO DE CONTACTO</strong></label>
                            <input class="form-control" [value]="vehiculo.propietario?.telcel || '-'" disabled />
                        </div>
                    </div>
                </ng-template>
            </ngb-panel>

            <ngb-panel id="panel-empresa">
                <ng-template ngbPanelTitle>
                    <strong>EMPRESA AFILIADA</strong>
                </ng-template>
                <ng-template ngbPanelContent>
                    <div class="row g-3">
                        <div class="col-md-6">
                            <label class="form-label"><strong>NOMBRE</strong></label>
                            <input class="form-control" [value]="vehiculo.nombreEmpresa?.nombre || '-'" disabled />
                        </div>
                        <div class="col-md-6">
                            <label class="form-label"><strong>NUMERO DE CONTACTO</strong></label>
                            <input class="form-control" [value]="vehiculo.nombreEmpresa?.celular || '-'" disabled />
                        </div>
                    </div>
                </ng-template>
            </ngb-panel>

            <ngb-panel id="panel-infracciones">
                <ng-template ngbPanelTitle>
                    <strong>INFRACCIONES SIMIT</strong>
                </ng-template>
                <ng-template ngbPanelContent>
                    <div class="row g-3">
                        <div class="col-md-6">
                            <label class="form-label"><strong>No. de paz y salvo o codigo de infraccion</strong></label>
                            <input type="number" class="form-control" [(ngModel)]="vehiculo.cod_infracion" placeholder="Ingrese codigo de infraccion" />
                        </div>
                        <div class="col-md-6">
                            <label class="form-label"><strong>Fecha ultima revision control de pagos</strong></label>
                            <input type="date" class="form-control" [(ngModel)]="vehiculo.ultima_revision" placeholder="Seleccione fecha de revision" />
                        </div>
                    </div>
                </ng-template>
            </ngb-panel>

            <ngb-panel id="panel-siniestros">
                <ng-template ngbPanelTitle>
                    <strong>SINIESTROS VIALES</strong>
                </ng-template>
                <ng-template ngbPanelContent>

                    <table class="table table-bordered table-hover">
                        <thead>
                            <tr>
                                <th class="text-center"><strong>CONSECUTIVO</strong></th>
                                <th class="text-center"><strong>FECHA</strong></th>
                                <th class="text-center"><strong>TIPO DE SINIESTRO</strong></th>
                                <th class="text-center"><strong>DESCRIPCION</strong></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let siniestro of vehiculo.siniestros; let i = index">
                                <td class="text-center">{{ siniestro.consecutivo}}</td>
                                <td class="text-center">{{ siniestro.fecha_siniestro | date: 'dd/MM/yyyy' }}</td>
                                <td class="text-center">{{ siniestro.tipoSiniestroData?.nombre || '-' }}</td>
                                <td class="text-center">{{ siniestro.descripcion_ocurrido || '-' }}</td>
                    </table>
                  <!--   <div class="row g-3">
                        <div class="col-md-4">
                            <label class="form-label"><strong>FECHA</strong></label>
                            <input type="date" class="form-control" [(ngModel)]="vehiculo.fecha_siniestros" placeholder="Seleccione fecha del siniestro" />
                        </div>
                        <div class="col-md-4">
                            <label class="form-label"><strong>LUGAR</strong></label>
                            <input type="text" class="form-control" [(ngModel)]="vehiculo.lugar_siniestros" placeholder="Ingrese lugar del siniestro" />
                        </div>
                        <div class="col-md-4">
                            <label class="form-label"><strong>AREA RURAL / URBANA</strong></label>
                            <select class="form-select" [ngModel]="obtenerAreaRuralSeleccionada(vehiculo)"
                                (ngModelChange)="actualizarAreaRuralVehiculo(vehiculo, $event)">
                                <option [ngValue]="null" disabled>Seleccione una opcion</option>
                                <option *ngFor="let municipio of municipios" [ngValue]="municipio.id">{{ municipio.nombre }}</option>
                            </select>
                        </div>
                    </div> -->
                </ng-template>
            </ngb-panel>

            <ngb-panel id="panel-vigencias">
                <ng-template ngbPanelTitle>
                    <strong>VIGENCIAS CORRESPONDIENTES A CADA UNO</strong>
                </ng-template>
                <ng-template ngbPanelContent>
                    <ul ngbNav #vigenciasNav="ngbNav" class="nav-tabs" [destroyOnHide]="false">
                        <li [ngbNavItem]="1">
                            <button ngbNavLink>SOAT</button>
                            <ng-template ngbNavContent>
                                <div class="row g-3 mt-1">
                                    <div class="col-md-6">
                                        <label class="form-label"><strong>VENCIMIENTO SOAT</strong></label>
                                        <input class="form-control" [value]="obtenerVencimientoSoat(vehiculo)" disabled />
                                    </div>
                                    <div class="col-md-6">
                                        <label class="form-label"><strong>ESTADO SOAT</strong></label>
                                        <input class="form-control" [value]="obtenerEstadoSoat(vehiculo)" disabled />
                                    </div>
                                </div>
                            </ng-template>
                        </li>

                        <li [ngbNavItem]="2">
                            <button ngbNavLink>RCC</button>
                            <ng-template ngbNavContent>
                                <div class="row g-3 mt-1">
                                    <div class="col-md-6">
                                        <label class="form-label"><strong>VENCIMIENTO RCC</strong></label>
                                        <input class="form-control" [value]="obtenerVencimientoRc(vehiculo)" disabled />
                                    </div>
                                    <div class="col-md-6">
                                        <label class="form-label"><strong>ESTADO RC</strong></label>
                                        <input class="form-control" [value]="obtenerEstadoRc(vehiculo)" disabled />
                                    </div>
                                </div>
                            </ng-template>
                        </li>

                        <li [ngbNavItem]="3">
                            <button ngbNavLink>TECNOMECÁNICA</button>
                            <ng-template ngbNavContent>
                                <div class="row g-3 mt-1">
                                    <div class="col-md-6">
                                        <label class="form-label"><strong>VECIMIENTO TECNOMECANICA</strong></label>
                                        <input class="form-control" [value]="obtenerVencimientoTecnomecanica(vehiculo)" disabled />
                                    </div>
                                    <div class="col-md-6">
                                        <label class="form-label"><strong>ESTADO TECNOMECANICA</strong></label>
                                        <input class="form-control" [value]="obtenerEstadoTecnomecanica(vehiculo)" disabled />
                                    </div>
                                </div>
                            </ng-template>
                        </li>

                        <li [ngbNavItem]="4">
                            <button ngbNavLink>MANTENIMIENTOS</button>
                            <ng-template ngbNavContent>
                                <div class="row g-3 mt-1">
                                    <div class="col-md-6">
                                        <label class="form-label"><strong>VENCIMIENTO MANTENIMIENTO PREVENTIVO</strong></label>
                                        <input class="form-control" [value]="obtenerVencimientoMantenimiento(vehiculo)" disabled />
                                    </div>
                                    <div class="col-md-6">
                                        <label class="form-label"><strong>ESTADO MANTENIMIENTO PREVENTIVO</strong></label>
                                        <input class="form-control" [value]="obtenerEstadoMantenimiento(vehiculo)" disabled />
                                    </div>
                                </div>
                            </ng-template>
                        </li>
                    </ul>

                    <div [ngbNavOutlet]="vigenciasNav" class="mt-3"></div>
                </ng-template>
            </ngb-panel>
        </ngb-accordion>
    </div>

    <div class="modal-footer">
        <button type="button" class="btn btn-light" (click)="modal.dismiss()">Cerrar</button>
        <button type="button" class="btn btn-primary" (click)="guardarVehiculoDesdeModal(modal)"
            [disabled]="guardandoTodo || vehiculoModalSeleccionado?.guardando">
            {{ vehiculoModalSeleccionado?.guardando ? 'Guardando...' : 'Guardar' }}
        </button>
    </div>
</ng-template>
